module.exports = __webpack_public_path__ + "img/left2.df2a6349.png";